
import { Component, Vue, Prop } from 'vue-property-decorator';
import RootView from './RootView';

import LanguageDropdown from '@/components/LanguageDropdown.vue';
import TooltipButton from '@/components/TooltipButton.vue';

@Component({
  components: {
    LanguageDropdown,
    TooltipButton
  }
})
export default class Navbar extends RootView {
  navDirection = "bottom-nav";

  $refs!: {
    nav: HTMLElement,
  }

  created() {
      ((that: any) => {
        window.onscroll = function () {
          // navbar function
              if (window.pageYOffset > (500 - that.$refs.nav.offsetHeight)) {
                  that.navDirection = "top-nav" ;
              } else {
                  that.navDirection = "bottom-nav";
              }
        }
      })(this);
  };
}
